import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';
import {$} from '../../../../node_modules/jquery';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;
declare function initiateMediaUsage(): any;

@Component({
  selector: 'app-question-area',
  templateUrl: './question-area.component.html',
  styleUrls: ['./question-area.component.scss']
})
export class QuestionAreaComponent {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;
  public ckeConfig: any;

  private loadMediaUsageSub : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ]
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';


    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadMediaUsageSub = this.dataSvc.getMediaUsageEvent().subscribe(() => this.initiateMediaUsage());
  }

  private initiateMediaUsage() {
    initiateMediaUsage();
    window["app-data-svc"] = this.dataSvc;
  }

  openCloseThis(id) {
    var content = document.getElementById(id).parentElement;
    var collapse = content.querySelector('.collapse');
    var itag = content.querySelector("i");
    if(collapse.classList.contains('in')){
      collapse.classList.remove('in');
      itag.classList.add("glyphicon-plus");
      itag.classList.remove("glyphicon-minus");
    }
    else{
      collapse.classList.add('in');
      itag.classList.remove("glyphicon-plus");
      itag.classList.add("glyphicon-minus");
    }
    this.checkAccordions();
    this.dataSvc.updateTheQuestionPosition();
}

checkAccordions(){
  var openCounter = 0;
  var closedCounter = 0;
  for(var i = 1; i < 4; i++){
    try{
      var content = document.getElementById('htmlCardHeader' + i).parentElement;
      var collapse = content.querySelector('.collapse');
      if(collapse.classList.contains('in')){
        openCounter++;
      }
      else{
        closedCounter++;
      }
    }
    catch(ex){}
    
  }
  if(closedCounter === 0){
    this.allClosed = false;
  }
  else{
    this.allClosed = true;
  }
  
}

closeAll(){
  try{
    this.close('htmlCardHeader1');
  }
  catch(ex){}try{
    this.close('htmlCardHeader2');
  }
  catch(ex){}try{
    this.close('htmlCardHeader3');
  }
  catch(ex){}
  
  this.allClosed = true;
  this.dataSvc.updateTheQuestionPosition();
  
}

openAll(){
  try{
    this.open('htmlCardHeader1');
  }
  catch(ex){}try{
    this.open('htmlCardHeader2');
  }
  catch(ex){}try{
    this.open('htmlCardHeader3');
  }
  catch(ex){}
  this.allClosed = false;
  this.dataSvc.updateTheQuestionPosition();
}

close(id){
  var content = document.getElementById(id).parentElement;
  var collapse = content.querySelector('.collapse');
    collapse.classList.remove('in');
    var itag = content.querySelector("i");
    sessionStorage.setItem("acc_" + this.questionId + "_" + id, "out");
    itag.classList.add("glyphicon-plus");
    itag.classList.remove("glyphicon-minus");
  
}

open(id){
  var content = document.getElementById(id).parentElement;
  var collapse = content.querySelector('.collapse');
    collapse.classList.add('in');
    var itag = content.querySelector("i");
    itag.classList.remove("glyphicon-plus");
    itag.classList.add("glyphicon-minus");
    sessionStorage.setItem("acc_" + this.questionId + "_" + id, "in");  
}

  displayDecimalInput(event) {
    event.stopPropagation();
    if (this.isTouchDevice == true) {
      this.showDecimalInput = true;
    }
  }

  hideDecimalInput() {
    this.showDecimalInput = false;
  }

  parseValueNumeric(obj){
    var regex = /[^0-9.-]*/g;
    if (obj.value.indexOf(",") > -1){
      alert("Comma values are not allowed for decimal places. Please enter a full-stop as a decimal.");
    }
    obj.value = obj.value.replace(regex, '');
  }

  addCharacter(event, character, obj) {
    event.stopPropagation();
    switch (character) {
        case "-":
            if (obj.length == 0)
              obj = character;
              break;
        case ".":
            if (obj.indexOf(".") < 0)
              obj += character;
            break;
        default:
          obj += character;
            break;
    }

    this.dataSvc.updateResponseCalculationVal(obj);
  }

  removeCharacter(event, obj) {
    event.stopPropagation();
      var htmlContent = obj
      htmlContent = htmlContent.substring(0, htmlContent.length - 1);
      obj = htmlContent;

      this.dataSvc.updateResponseCalculationVal(obj);
  }

  getQuestionText() {
    var qTxt = this.dataSvc.currentQuestion().Question.QuestionText;

    if (!this.dataSvc.currentUser.ScheduleCandidate.SubtitlesAllowed && qTxt.includes("<track")) {
      qTxt = qTxt.replaceAll(/\s*<track[^>]*\/>/gm, '');
    }

    return qTxt;
  }
}
